module.exports = __webpack_public_path__ + "img/slider-arrow.89ec7fd9.svg";